/**
 * Step 4: Sparpläne — Phase-1b-Skelett ohne Backend-Modell.
 *
 * Bewusst nur Hinweis-Karte, weil ohne CSV-Import die manuelle Erfassung
 * von Sparplan-Metadaten redundant zur Position-Erfassung wäre. Der CSV-
 * Importer (Phase 1b) erkennt wiederkehrende Käufe automatisch.
 */
export function Step4SavingPlans() {
  return (
    <div className="flex flex-col gap-6">
      <div>
        <h2 className="tracked-caps text-sm text-ink">Sparpläne</h2>
        <p className="mt-3 max-w-2xl font-mono text-sm leading-6 text-muted">
          Sparpläne werden automatisch aus dem CSV-Import erkannt — wiederkehrende Käufe mit
          derselben ISIN und konstantem Betrag. Diese Erkennung folgt mit Phase 1b.
        </p>
      </div>

      <section className="border border-bernstein/30 bg-bernstein/5 px-5 py-4">
        <p className="tracked-caps text-[10px] text-bernstein">Phase 1b · CSV-Import</p>
        <p className="mt-2 font-mono text-sm leading-6 text-ink">
          Sobald der Consors-Adapter aktiv ist, sammelt Sextant aus deinem Umsätze-Export die
          aktiven Sparpläne und stellt sie zur Bestätigung mit Betrag, Frequenz und Ausführungstag
          dar.
        </p>
        <p className="mt-3 font-mono text-xs text-muted">
          Bis dahin: Schritt überspringen und später nachholen — kein Daten-Verlust.
        </p>
      </section>

      <section>
        <p className="tracked-caps mb-3 text-[10px] text-faint">Vorbereitung für Phase 1b</p>
        <ul className="flex flex-col gap-1.5 font-mono text-sm text-muted">
          <li>· CSV-Export Consors-Umsätze (max. 2 Jahre)</li>
          <li>· ISINs der aktiven Sparpläne notiert</li>
          <li>· Monatliche Beträge bekannt</li>
        </ul>
      </section>
    </div>
  )
}
